export default __webpack_public_path__ + "static/media/python4.dea72a46.jpg";